export function isDefined<T>(optionId: T | null | undefined): optionId is T {
  return !!optionId;
}

export function ampersandJoiner(items?: string[]): string {
  if (!items || items.length === 0) {
    return '';
  }

  if (items.length === 1) {
    return items[0];
  }

  if (items.length === 2) {
    return items[0] + ' & ' + items[1];
  }

  let returnString = '';

  for (let i = 0; i < items.length - 2; i++) {
    returnString += items[i];
    returnString += ', ';
  }
  returnString += items[items.length - 2];
  returnString += ' & ';
  returnString += items[items.length - 1];

  return returnString;
}
